export const FAIR_MODE_CLIENT_SECRET = 'FAIR';
